import { render, staticRenderFns } from "./ItemPackagingUnits.vue?vue&type=template&id=a020e070&scoped=true"
import script from "./ItemPackagingUnits.vue?vue&type=script&lang=ts"
export * from "./ItemPackagingUnits.vue?vue&type=script&lang=ts"
import style0 from "./ItemPackagingUnits.vue?vue&type=style&index=0&id=a020e070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a020e070",
  null
  
)

export default component.exports